// extracted by mini-css-extract-plugin
export default {"loading":"PropSearchBreadcrumb_loading__ztG4q","separator":"PropSearchBreadcrumb_separator__Y1Bmw","bcLabel":"PropSearchBreadcrumb_bcLabel__5hLqZ"};